import store from '@/store';
import { dataGet } from '@fps/vue-toolkit/dist/util';
import mutations from '@/store/temp/temp.mutationlist';
import { loadFbSdk } from 'facebook-login-vuejs/src/helpers';

export default {
  canActivate() {
    const dataPromiseArray = [];

    const facebookInit = dataGet('state.temp.social.facebookInit', store);
    const facebookAppId = dataGet('state.config.facebookAppId', store);

    if (!facebookInit) {
      this.isWorking = true;
      dataPromiseArray.push(loadFbSdk(facebookAppId, 'v2.10'));
      store.commit(mutations.FACEBOOK_INITIALIZED, true);
    }

    return Promise.all(dataPromiseArray);
  },
};



// WEBPACK FOOTER //
// ./src/guards/auth-services.js